import React, { Component } from 'react';
import { RadioButtonGroup } from '../../ui';
import { translate } from 'react-i18next';
import { UserDataConsumer } from '../../utils';
import { View } from 'react-native';
import { FoodPreference } from 'fitbeat.models';

interface IProps {
    t: (key: string) => string;
    optionTextStyle?: object;
    selectedFoodPreference: FoodPreference;
    setFoodPreferenceToAllFoodGroups: () => void;
    setFoodPreferenceToVegetarian: () => void;
    setFoodPreferenceToVegan: () => void;
}

class FoodGroupSelection extends Component<IProps> {
    public render() {
        const { t, optionTextStyle = {}, selectedFoodPreference } = this.props;
        return (
          <View>
            <RadioButtonGroup
              options={[
                {
                  name: t('omni'),
                  isSelected:
                    selectedFoodPreference === FoodPreference.AllFoodGroups,
                  setOption: this.props.setFoodPreferenceToAllFoodGroups,
                  style: optionTextStyle,
                },
                {
                  name: t('Vegetarian'),
                  isSelected:
                    selectedFoodPreference === FoodPreference.Vegetarian,
                  setOption: this.props.setFoodPreferenceToVegetarian,
                  style: optionTextStyle,
                },
                {
                  name: t('Vegan'),
                  isSelected: selectedFoodPreference === FoodPreference.Vegan,
                  setOption: this.props.setFoodPreferenceToVegan,
                  style: optionTextStyle,
                },
              ]}
            />
          </View>
        );
    }
}

export default UserDataConsumer(translate(['nutrition', 'tracking'], { wait: true })(FoodGroupSelection));
